import { resolveCoreMessage } from "./coreExport.js";

const APP_MESSAGE_KEY = /^(?:mobile|common|core)\./;

/**
 * Resolve thrown errors and message keys for display.
 *
 * @param {ReturnType<import("./createDisplay.js").createDisplay>} display
 * @param {unknown} error
 */
export function resolveAppError(display, error) {
  if (isCoreError(error)) {
    return resolveCoreMessage(display, { key: error.key, params: error.params })
      ?? display.t("common.unknownError");
  }

  const message = error instanceof Error ? error.message : String(error ?? "");
  if (APP_MESSAGE_KEY.test(message)) {
    return display.t(message);
  }

  return message || display.t("common.unknownError");
}

/**
 * @param {unknown} error
 * @returns {error is Error & { key: string, params?: Record<string, unknown> }}
 */
function isCoreError(error) {
  return Boolean(
    error
    && typeof error === "object"
    && error.name === "CoreError"
    && typeof error.key === "string",
  );
}
